<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
      <el-form-item label="名称" prop="examineTypeName">
        <el-input v-model="dataForm.examineTypeName" placeholder="名称"></el-input>
      </el-form-item>
      <el-form-item label="微信通知" prop="isNotify">
        <el-switch
                v-model="dataForm.isNotify"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-text="是"
                inactive-text="否"
                :active-value="1"
                :inactive-value="0">
        </el-switch>
      </el-form-item>
      <el-form-item label="类型 " prop="type">
        <el-radio-group v-model="dataForm.type">
          <el-radio :label="0">校级</el-radio>
          <el-radio :label="1">班级</el-radio>
        </el-radio-group>
      </el-form-item>
<!--      <el-form-item label="评价流程" prop="defaultThread">-->
<!--        <el-switch-->
<!--                v-model="dataForm.defaultThread"-->
<!--                active-color="#13ce66"-->
<!--                inactive-color="#ff4949"-->
<!--                active-text="默认流程"-->
<!--                inactive-text="按任务表评价班级"-->
<!--                :active-value="1"-->
<!--                :inactive-value="0">-->
<!--        </el-switch>-->
<!--      </el-form-item>-->
      <el-form-item label="排序" prop="weight">
        <el-input v-model="dataForm.weight" placeholder="排序字段"></el-input>
      </el-form-item>
      <el-form-item label="分数限制" prop="isStart">
        <el-switch
                v-model="dataForm.isStart"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-text="是"
                inactive-text="否"
                :active-value="1"
                :inactive-value="0">
        </el-switch>
      </el-form-item>
      <el-form-item label="最高分数" v-if="dataForm.isStart===1" prop="scoreSet">
        <el-input v-model.trim="dataForm.scoreSet" placeholder="请输入整数"></el-input>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        examineTypeName: '',
        creator: '',
        updater: '',
        createDate: '',
        updateDate: '',
        schoolId: '',
        deleted: '',
        weight: '',
        isNotify: '',
        defaultThread: 1,
        isStart: '',
        scoreSet: '',
        type: 0
      }
    }
  },
  computed: {
    dataRule () {
      return {
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.dataForm.resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get('/studentEvaluate/studentExamineType/' + this.dataForm.id).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs.dataForm.validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/studentEvaluate/studentExamineType/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { leading: true, trailing: false })
  }
}
</script>
